<div class="app-inner-layout">
    <section class="container header-section-website">
        <div class="row">
            <div class="col-8 flex-row d-flex justify-content-start align-items-center">
                <a href="https://www.mobilitateurbana4.ro" class="back-link"><i class="fa-solid fa-angles-left"></i>
                    Înapoi în site</a>
            </div>
            <div class="col-4 flex-row d-flex justify-content-end align-items-center">
                <a href="https://www.mobilitateurbana4.ro">
                    <img src="../../../assets/img/logo-ps4-dmu.png" class="img-fluid" />
                </a>
            </div>
        </div>
    </section>
    <section class="container-fluid header-bg">
        <div class="bg-overlay"></div>
        <div class="row">
            <div class="container">
                <div class="col-sm-12">
                    <h4>MOBILITATE URBANĂ</h4>
                    <br />
                    <h1>Documente</h1>
                </div>
            </div>
        </div>
    </section>

    <!-- Progress Stepper -->
    <div class="step-content mt-4" *ngIf="isTokenAccess">
        <mat-card class="container progress-stepper">
            <div class="stepper-container">
                <!-- Step 1: Verificare Token -->
                <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 1">check</mat-icon>
                        <span *ngIf="currentStep <= 1">1</span>
                    </div>
                    <div class="step-label">Verificare<br>Acces</div>
                </div>

                <!-- Connector 1->2 -->
                <div class="step-connector" [class.completed]="currentStep > 1"></div>

                <!-- Step 2: Verificare OTP -->
                <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 2">check</mat-icon>
                        <span *ngIf="currentStep <= 2">2</span>
                    </div>
                    <div class="step-label">Confirmare Cod</div>
                </div>

                <!-- Connector 2->3 -->
                <div class="step-connector" [class.completed]="currentStep > 2"></div>

                <!-- Step 3: Descărcare Document -->
                <div class="step-item" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 3">check</mat-icon>
                        <span *ngIf="currentStep <= 3">3</span>
                    </div>
                    <div class="step-label">Descărcare<br>Document</div>
                </div>
            </div>
        </mat-card>
    </div>

    <!-- ORIGINAL STEPPER - COMMENTED OUT -->
    <!-- 
    <div class="container mt-4">
        <div class="progress-stepper">
            <div class="stepper-container" [class.token-access]="isTokenAccess">
                Step 1
                <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1"
                    (click)="goToStep(1)" [class.clickable]="currentStep > 1">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 1">check</mat-icon>
                        <span *ngIf="currentStep <= 1">1</span>
                    </div>
                    <div class="step-label">
                        <span *ngIf="!isTokenAccess">Verificare<br>Identitate</span>
                        <span *ngIf="isTokenAccess">Verificare<br>Token</span>
                    </div>
                </div>

                Connector 1->2
                <div class="step-connector" [class.completed]="currentStep > 1"></div>

                Step 2
                <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2"
                    (click)="goToStep(2)" [class.clickable]="currentStep > 2">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 2">check</mat-icon>
                        <span *ngIf="currentStep <= 2">2</span>
                    </div>
                    <div class="step-label">Verificare OTP</div>
                </div>

                Connector 2->3 (doar dacă nu e token access)
                <div *ngIf="!isTokenAccess" class="step-connector" [class.completed]="currentStep > 2"></div>

                Step 3 (doar dacă nu e token access)
                <div *ngIf="!isTokenAccess" class="step-item" [class.active]="currentStep === 3"
                    [class.completed]="currentStep > 3">
                    <div class="step-circle">
                        <mat-icon *ngIf="currentStep > 3">check</mat-icon>
                        <span *ngIf="currentStep <= 3">3</span>
                    </div>
                    <div class="step-label">Descărcare<br>Document</div>
                </div>
            </div>
        </div>
    </div>
    -->

    <!-- Error Message -->
    <mat-card *ngIf="errorMessage" class="error-card">
        <mat-card-content>
            <div class="error-content">
                <mat-icon color="warn">error</mat-icon>
                <span>{{ errorMessage }}</span>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Se procesează...</p>
    </div>

    <!-- Mesaj pentru utilizatorii fără token -->
    <div *ngIf="!isTokenAccess" class="step-content mt-4">
        <mat-card class="container access-message-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon color="warn">info</mat-icon>
                </div>
                <mat-card-title style="color: red">Acces Restricționat</mat-card-title>
            </mat-card-header>

            <mat-card-content class="text-center">
                <p class="access-message">
                    Vă rugăm să accesați documentele doar prin linkul primit pe e-mail (inbox sau spam).
                    Vă mulțumim pentru înțelegere!
                </p>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ORIGINAL STEP 1: Verification - COMMENTED OUT -->
    <!-- 
    <div *ngIf="currentStep === 1 && !isTokenAccess" class="step-content mt-4">
        <mat-card class="container verification-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>verified_user</mat-icon>
                </div>
                <mat-card-title>Verificare Identitate</mat-card-title>
                <mat-card-subtitle>Completați următoarele câmpuri pentru verificare</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <form [formGroup]="verificationForm" (ngSubmit)="submitVerification()">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>CNP/CIF</mat-label>
                        <input matInput formControlName="identificator" placeholder="Introduceți CNP sau CIF">
                        <mat-icon matSuffix>person</mat-icon>
                        <mat-error *ngIf="cnpCifError">{{ cnpCifError }}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Simbol</mat-label>
                        <mat-select formControlName="parcare_id" (openedChange)="onSimbolClosed()">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="simbolControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="showMessage" disabled>
                                <span *ngIf="!simbolControl.value || simbolControl.value.length < 2">Vă rugăm să
                                    introduceți 2 caractere sau mai multe</span>
                                <span *ngIf="isSimboluriLoading && simbolControl.value.length >= 2">Searching...</span>
                                <span
                                    *ngIf="!isSimboluriLoading && loadComplete && simboluri.length === 0 && simbolControl.value && simbolControl.value.length >= 2">No
                                    results found</span>
                            </mat-option>

                            <mat-option *ngFor="let simbol of simboluri" [value]="simbol.id">
                                {{ simbol.text }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>tag</mat-icon>
                        <mat-error *ngIf="simbolError">{{ simbolError }}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Loc</mat-label>
                        <input matInput formControlName="parcare_no" placeholder="Introduceți locul">
                        <mat-icon matSuffix>location_on</mat-icon>
                        <mat-error *ngIf="locError">{{ locError }}</mat-error>
                    </mat-form-field>

                    <mat-card-actions align="end">
                        <button mat-raised-button color="primary" type="submit" [disabled]="isLoading">
                            <mat-icon>arrow_forward</mat-icon>
                            Continuă
                        </button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
    -->

    <!-- Step 1: Verificare Token (doar loading) -->
    <div *ngIf="isTokenAccess && currentStep === 1" class="step-content mt-4">
        <mat-card class="container verification-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>verified_user</mat-icon>
                </div>
                <mat-card-title>Verificare Token</mat-card-title>
                <mat-card-subtitle>Se verifică validitatea tokenului...</mat-card-subtitle>
            </mat-card-header>
        </mat-card>
    </div>

    <!-- Step 2: OTP Verification -->
    <div *ngIf="isTokenAccess && currentStep === 2" class="step-content mt-4">
        <mat-card class="container otp-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>security</mat-icon>
                </div>
                <mat-card-title>Confirmare Cod</mat-card-title>
                <mat-card-subtitle>Codul este format din 6 cifre</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="text-center">
                <!-- Contact Information - Compact Design -->
                <div class="contact-info-compact" *ngIf="documentData">
                    <p class="contact-title">Pentru a accesa documentele, introduceți codul OTP primit prin:</p>
                    <div class="contact-row">
                        <div class="contact-item-compact" *ngIf="documentData.telefon">
                            <mat-icon>phone</mat-icon>
                            <span>Telefon: {{ documentData.telefon }}</span>
                        </div>
                        <div class="contact-item-compact" *ngIf="documentData.email">
                            <mat-icon>email</mat-icon>
                            <span>E-mail: {{ documentData.email }}</span>
                        </div>
                    </div>
                    <p class="contact-footer">Dacă nu ați primit codul, îl puteți retrimite.</p>



                    <div class="resend-buttons">
                        <button mat-button color="primary" type="button" (click)="resendOTPSms()"
                            [disabled]="isLoading || resendSmsTimer > 0">
                            <mat-icon>sms</mat-icon>
                            <span *ngIf="resendSmsTimer === 0">Retrimite SMS</span>
                            <span *ngIf="resendSmsTimer > 0">Retrimite SMS ({{ resendSmsTimer }}s)</span>
                        </button>

                        <button mat-button color="primary" type="button" (click)="resendOTPEmail()"
                            [disabled]="isLoading || resendEmailTimer > 0">
                            <mat-icon>email</mat-icon>
                            <span *ngIf="resendEmailTimer === 0">Trimite prin Email</span>
                            <span *ngIf="resendEmailTimer > 0">Trimite prin Email ({{ resendEmailTimer }}s)</span>
                        </button>
                    </div>
                </div>

                <form [formGroup]="otpForm" (ngSubmit)="submitOTP()">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Cod</mat-label>
                        <input matInput formControlName="otpCode" maxlength="6" class="otp-input">
                        <mat-icon matSuffix>lock</mat-icon>
                        <mat-hint style="color: red;">Introduceți codul primit prin {{ getCurrentChannelText()
                            }}</mat-hint>
                        <mat-error *ngIf="otpError">{{ otpError }}</mat-error>
                    </mat-form-field>

                    <!-- Checkbox-uri pentru acorduri -->
                    <div class="agreements-container">
                        <div class="terms-declaration">
                            <mat-checkbox formControlName="dataProcessingAgreement" color="primary">
                            </mat-checkbox>
                            <p>
                                Declar că sunt de acord cu transmiterea actelor administrative pe cale electronică <span
                                    class="red-text">*</span>
                            </p>
                        </div>

                        <div class="terms-declaration">
                            <mat-checkbox formControlName="privacyAgreement" color="primary">
                            </mat-checkbox>
                            <p>
                                Sunt de acord cu
                                <a href="https://www.mobilitateurbana4.ro/politica-de-confidentialitate/"
                                    target="_blank" class="privacy-link">
                                    <i>Termenii și Condițiile de Confidențialitate</i>
                                </a>
                                <span class="red-text"> *</span> (conform GDPR)
                            </p>
                        </div>
                    </div>

                    <mat-card-actions class="otp-actions">
                        <button mat-raised-button color="primary" type="submit"
                            [disabled]="isLoading || !isFormValid()">
                            <mat-icon>check</mat-icon>
                            Pasul următor
                        </button>

                        <div class="navigation-buttons">
                            <!-- Back button sau Reset button -->
                            <!-- COMMENTED OUT - Original back button for non-token access -->
                            <!-- 
                            <button *ngIf="!isTokenAccess" mat-button color="accent" type="button" (click)="goToStep(1)"
                                [disabled]="isLoading">
                                <mat-icon>arrow_back</mat-icon>
                                Înapoi
                            </button>
                            -->

                            <!-- <button mat-button color="warn" type="button" (click)="resetToStep1()"
                                [disabled]="isLoading">
                                <mat-icon>refresh</mat-icon>
                                Reset
                            </button> -->
                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ORIGINAL STEP 2: OTP Verification - COMMENTED OUT -->
    <!-- 
    <div *ngIf="currentStep === 2" class="step-content mt-4">
        <mat-card class="container otp-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>security</mat-icon>
                </div>
                <mat-card-title>Verificare Cod OTP</mat-card-title>
                <mat-card-subtitle>Introduceți codul primit prin SMS</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="text-center">
                <form [formGroup]="otpForm" (ngSubmit)="submitOTP()">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Cod OTP</mat-label>
                        <input matInput formControlName="otpCode" maxlength="6" class="otp-input">
                        <mat-icon matSuffix>lock</mat-icon>
                        <mat-error *ngIf="otpError">{{ otpError }}</mat-error>
                    </mat-form-field>

                    <mat-card-actions class="otp-actions">
                        <button mat-raised-button color="primary" type="submit" [disabled]="isLoading">
                            <mat-icon>check</mat-icon>
                            Verifică Cod
                        </button>

                        <div class="navigation-buttons">
                            Back button sau Reset button
                            <button *ngIf="!isTokenAccess" mat-button color="accent" type="button" (click)="goToStep(1)"
                                [disabled]="isLoading">
                                <mat-icon>arrow_back</mat-icon>
                                Înapoi
                            </button>

                            <button *ngIf="isTokenAccess" mat-button color="warn" type="button" (click)="resetToStep1()"
                                [disabled]="isLoading">
                                <mat-icon>refresh</mat-icon>
                                Reset
                            </button>
                        </div>

                        <div class="resend-buttons">
                            <button mat-button color="accent" type="button" (click)="resendOTPSms()"
                                [disabled]="isLoading || resendSmsTimer > 0">
                                <mat-icon>sms</mat-icon>
                                <span *ngIf="resendSmsTimer === 0">Retrimite SMS</span>
                                <span *ngIf="resendSmsTimer > 0">Retrimite SMS ({{ resendSmsTimer }}s)</span>
                            </button>

                            <button mat-button color="accent" type="button" (click)="resendOTPEmail()"
                                [disabled]="isLoading || resendEmailTimer > 0">
                                <mat-icon>email</mat-icon>
                                <span *ngIf="resendEmailTimer === 0">Trimite prin Email</span>
                                <span *ngIf="resendEmailTimer > 0">Trimite prin Email ({{ resendEmailTimer }}s)</span>
                            </button>
                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
    -->

    <!-- Step 3: Document Download -->
    <div *ngIf="isTokenAccess && currentStep === 3" class="step-content mt-4">
        <!-- Download Card -->
        <mat-card class="container download-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>download</mat-icon>
                </div>
                <mat-card-title>Document Disponibil</mat-card-title>
                <mat-card-subtitle>Vă rugăm să descărcați documentul atașat</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="download-content text-center">
                <div class="document-icon">
                    <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <p class="download-message">Documentul dvs. este gata pentru descărcare</p>
            </mat-card-content>

            <mat-card-actions>
                <div class="download-actions">
                    <button mat-raised-button color="primary" class="download-button mb-3" (click)="downloadDocument()"
                        [disabled]="isLoading">
                        <mat-icon>download</mat-icon>
                        <span *ngIf="!isLoading">Descarcă Document</span>
                        <span *ngIf="isLoading">Se descarcă...</span>
                    </button>

                    <!-- COMMENTED OUT - Original back button to OTP -->
                    <!-- 
                    <button *ngIf="!isTokenAccess" mat-button color="accent" type="button" (click)="goToStep(2)"
                        [disabled]="isLoading">
                        <mat-icon>arrow_back</mat-icon>
                        Înapoi la OTP
                    </button>
                    -->
                </div>
            </mat-card-actions>
        </mat-card>

        <!-- Useful Links Section -->
        <mat-card class="container links-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>link</mat-icon>
                </div>
                <mat-card-title>Link-uri Utile</mat-card-title>
                <mat-card-subtitle>Alte servicii disponibile</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <mat-list class="useful-links">
                    <mat-list-item *ngFor="let link of usefulLinks" class="link-item">
                        <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="link-content">
                            <div class="link-avatar">
                                <mat-icon>{{ link.icon }}</mat-icon>
                            </div>
                            <div class="link-title">{{ link.title }}</div>
                        </a>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- ORIGINAL STEP 3: Document Download - COMMENTED OUT -->
    <!-- 
    <div *ngIf="currentStep === 3 || (isTokenAccess && currentStep === 2 && documentData)" class="step-content mt-4">
        Download Card
        <mat-card class="container download-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>download</mat-icon>
                </div>
                <mat-card-title>Document Disponibil</mat-card-title>
                <mat-card-subtitle>Vă rugăm să descărcați documentul atașat</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="download-content text-center">
                <div class="document-icon">
                    <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <p class="download-message">Documentul dvs. este gata pentru descărcare</p>
            </mat-card-content>

            <mat-card-actions>
                <div class="download-actions">
                    <button mat-raised-button color="primary" class="download-button" (click)="downloadDocument()"
                        [disabled]="isLoading">
                        <mat-icon>download</mat-icon>
                        <span *ngIf="!isLoading">Descarcă Document</span>
                        <span *ngIf="isLoading">Se descarcă...</span>
                    </button>

                    Back button
                    <button *ngIf="!isTokenAccess" mat-button color="accent" type="button" (click)="goToStep(2)"
                        [disabled]="isLoading">
                        <mat-icon>arrow_back</mat-icon>
                        Înapoi la OTP
                    </button>
                </div>
            </mat-card-actions>
        </mat-card>

        Useful Links Section
        <mat-card class="container links-card">
            <mat-card-header class="d-flex justify-content-center">
                <div mat-card-avatar>
                    <mat-icon>link</mat-icon>
                </div>
                <mat-card-title>Link-uri Utile</mat-card-title>
                <mat-card-subtitle>Alte servicii disponibile</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
                <mat-list class="useful-links">
                    <mat-list-item *ngFor="let link of usefulLinks" class="link-item">
                        <a [href]="link.url" target="_blank" rel="noopener noreferrer" mat-list-item
                            class="link-content">
                            <div matListItemAvatar>
                                <mat-icon [class]="link.icon.replace('fas fa-', '')">{{ link.icon.replace('fas fa-', '')
                                    }}</mat-icon>
                            </div>
                            <div matListItemTitle>{{ link.title }}</div>
                            <mat-icon matListItemMeta>chevron_right</mat-icon>
                        </a>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
    -->
</div>